// Kopf über der zitierten Mail bei Antworten/Weiterleitungen – wie Outlook Desktop, aber in der Sprache der Mail
// (localeSelected im Email-Modal), nicht in der Sprache der Oberfläche.

const LABELS = {
    de_DE: {from: 'Von:', sent: 'Gesendet:', to: 'An:', cc: 'Cc:', subject: 'Betreff:'},
    // französisches Outlook: geschütztes Leerzeichen vor dem Doppelpunkt
    fr: {from: 'De&nbsp;:', sent: 'Envoyé&nbsp;:', to: 'À&nbsp;:', cc: 'Cc&nbsp;:', subject: 'Objet&nbsp;:'},
    en: {from: 'From:', sent: 'Sent:', to: 'To:', cc: 'Cc:', subject: 'Subject:'},
};

const INTL_LOCALE = {de_DE: 'de-DE', fr: 'fr-FR', en: 'en-GB'};

function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// "Name <adresse>", ohne Namen nur die Adresse (Outlook doppelt sie nicht)
function person(name, address) {
    const cleanName = (name || '').trim();
    if (!address) {
        return escapeHtml(cleanName);
    }
    return cleanName && cleanName.toLowerCase() !== address.toLowerCase()
        ? `${escapeHtml(cleanName)} &lt;${escapeHtml(address)}&gt;`
        : escapeHtml(address);
}

// "07.04.2026 14:28:00" → Outlook-Schreibweise der jeweiligen Sprache
export function formatSentDate(value, locale) {
    const match = String(value || '').match(/^(\d{2})\.(\d{2})\.(\d{4})(?: (\d{2}):(\d{2}))?/);
    if (!match) {
        return escapeHtml(value);
    }
    const [, day, month, year, hours = '00', minutes = '00'] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes));
    const intl = INTL_LOCALE[locale] || INTL_LOCALE.de_DE;
    const weekday = new Intl.DateTimeFormat(intl, {weekday: 'long'}).format(date);
    const monthName = new Intl.DateTimeFormat(intl, {month: 'long'}).format(date);
    const dayNumber = Number(day);

    if (locale === 'fr') {
        return `${weekday} ${dayNumber} ${monthName} ${year} ${hours}:${minutes}`;
    }
    if (locale === 'en') {
        const hour = Number(hours);
        return `${weekday}, ${monthName} ${dayNumber}, ${year} ${hour % 12 || 12}:${minutes} ${hour < 12 ? 'AM' : 'PM'}`;
    }
    return `${weekday}, ${dayNumber}. ${monthName} ${year} ${hours}:${minutes}`;
}

export default function replyHeader(email, locale = 'de_DE') {
    const labels = LABELS[locale] || LABELS.de_DE;
    const list = addresses => (addresses || []).map(contact => person(contact.name, contact.email)).join('; ');

    let lines = `<b>${labels.from}</b> ${person(email.fromName, email.fromAddress)}<br>`
        + `<b>${labels.sent}</b> ${formatSentDate(email.date, locale)}<br>`
        + `<b>${labels.to}</b> ${list(email.toAddresses)}<br>`;
    if (email.ccAddresses && email.ccAddresses.length) {
        lines += `<b>${labels.cc}</b> ${list(email.ccAddresses)}<br>`;
    }
    lines += `<b>${labels.subject}</b> ${escapeHtml(email.subject)}`;

    // Marker: hier beginnt der Verlauf (Email-Editor zeigt ihn gesperrt, emailHtml.js)
    return '<!-- emailQuoteStart --><p>&nbsp;</p><p>&nbsp;</p><div style="border:none;border-top:solid #E1E1E1 1.0pt;padding:3.0pt 0 0 0">'
        + '<p class=MsoNormal><span style="mso-fareast-font-family:Times New Roman;mso-fareast-language:ZH-CN">'
        + lines
        + '</span></p></div>';
}
